module.exports = __webpack_public_path__ + "static/media/ecom.8ccaa4de.png";